import type { Routes } from '../../shares/types';
import { ModalBasic } from './basic';

export const MODAL_ROUTES: Routes = {
	modal: {
		basic: ModalBasic,
	},
};
